import { Injectable, inject } from '@angular/core';
import { IRemoteError, ISeverityHandler, SeverityHandler, TSeverityCallback, TSeverityCode } from '@partners/errors';
import { EMPTY, Observable } from 'rxjs';
import { NavigationAdapter } from '../../../navigation/services/navigation-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class CardSeverities extends SeverityHandler implements ISeverityHandler {
  override handlers: Map<TSeverityCode, TSeverityCallback>;
  private _navAdapter = inject(NavigationAdapter);
  constructor() {
    super();

    this.handlers = new Map<TSeverityCode, TSeverityCallback>()
      .set('W_0824', (error: IRemoteError) => {
        return this.activateDebitCardAlertHandler();
      })
      .set('W_0031', (error: IRemoteError) => {
        return this.activateVerificationAlertHandler();
      })
      .set('W_0403', (error: IRemoteError) => {
        return this.activateVerificationAlertHandler();
      })
      .set('W_0032', (error: IRemoteError) => {
        return this.activateIdentificationAlertHandler();
      });
  }

  private activateDebitCardAlertHandler(): Observable<never> {
    this._navAdapter.toAlert('debit-card-alert');
    return EMPTY;
  }

  private activateIdentificationAlertHandler(): Observable<never> {
    this._navAdapter.toAlert('card-identification-alert');
    return EMPTY;
  }

  private activateVerificationAlertHandler(): Observable<never> {
    this._navAdapter.toAlert('card-verification-alert');
    return EMPTY;
  }
}
